"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Faq = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Faq = function Faq(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12 0 3.183-1.264 6.235-3.515 8.485C18.235 22.735 15.183 24 12 24 5.373 24 0 18.627 0 12S5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-2.652-1.054-5.196-2.929-7.071C17.196 3.054 14.652 2 12 2zm.71 14.29c.093.097.167.208.22.33.093.245.093.516 0 .76-.051.12-.126.229-.22.32-.187.19-.443.299-.71.3-.13-.002-.26-.029-.38-.08-.24-.107-.432-.3-.54-.54-.107-.242-.107-.518 0-.76.046-.126.121-.239.22-.33.39-.387 1.02-.387 1.41 0zm-.084-10.23c1.956.335 3.381 2.002 3.374 3.947 0 2.684-3.621 3.89-3.792 3.947-.092.027-.188.043-.284.046-.466-.001-.862-.333-.935-.783-.073-.45.199-.885.64-1.028.636-.213 2.475-1.067 2.475-2.182.018-1.047-.743-1.953-1.796-2.138-1.053-.184-2.087.407-2.442 1.395-.089.34-.366.602-.716.677-.35.075-.713-.05-.939-.323-.225-.273-.274-.647-.127-.966.667-1.832 2.585-2.927 4.542-2.592z"
  }));
};

exports.Faq = Faq;